import React from 'react';
import { Card } from '../ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Badge } from '../ui/badge';
import { Star, ShieldCheck, Briefcase, Route } from 'lucide-react';
import PrivateCallButton from '../PrivateCallButton';
import { photoSrc } from '../../lib/photos';

const GENDER_LABEL = { male: 'Male driver', female: 'Female driver', other: 'Driver' };

// Who is coming: photo, rating, gender, experience, trips, Driver ID + private call.
export const DriverProfileCard = ({ booking }) => {
  const p = booking.driverProfile;
  const name = p?.fullName || booking.driverName || 'Driver';
  return (
    <Card className="p-6 mb-6" data-testid="driver-profile-card">
      <h3 className="font-semibold text-lg mb-4">Your Driver</h3>
      <div className="flex items-start gap-4">
        <Avatar className="w-20 h-20 ring-2 ring-border">
          <AvatarImage src={photoSrc(p?.photoUrl)} alt={name} className="object-cover" data-testid="driver-profile-photo" />
          <AvatarFallback className="text-2xl" data-testid="driver-profile-initials">{name[0]}</AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h4 className="font-semibold text-lg" data-testid="driver-profile-name">{name}</h4>
            <Badge variant="secondary" className="bg-green-50 text-green-700 border border-green-200">
              <ShieldCheck className="w-3 h-3 mr-1" />Verified
            </Badge>
          </div>
          <div className="flex items-center gap-3 mt-1 text-sm text-muted-foreground flex-wrap">
            <span className="flex items-center gap-1 font-semibold text-foreground" data-testid="driver-profile-rating">
              <Star className="w-4 h-4 text-yellow-500 fill-current" />{(p?.rating ?? 5).toFixed(1)}
            </span>
            {p?.gender && <span className="capitalize" data-testid="driver-profile-gender">{GENDER_LABEL[p.gender] || p.gender}</span>}
            {p?.experienceYears != null && (
              <span className="flex items-center gap-1" data-testid="driver-profile-experience">
                <Briefcase className="w-4 h-4" />{p.experienceYears} yrs exp
              </span>
            )}
            {p?.totalTrips != null && (
              <span className="flex items-center gap-1" data-testid="driver-profile-trips">
                <Route className="w-4 h-4" />{p.totalTrips} trips
              </span>
            )}
          </div>
          {(p?.driverId || booking.driverPublicId) && (
            <p className="text-xs text-muted-foreground mt-1 font-mono" data-testid="driver-profile-id">
              Driver ID: {p?.driverId || booking.driverPublicId}
            </p>
          )}
        </div>
        <PrivateCallButton contactName={name} contactNumber={booking.driverPhone || ''} userType="user" />
      </div>
    </Card>
  );
};
